import { Injectable } from '@angular/core'
import { BehaviorSubject, fromEvent, map, Observable, startWith } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class ScreenService {
	public readonly isFullscreen$: Observable<boolean> = fromEvent(document, 'fullscreenchange').pipe(
		startWith(!!document.fullscreenElement),
		map((): boolean => !!document.fullscreenElement),
	)

	public isWasAFK$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

	get isAFK(): boolean {
		return document.visibilityState === 'hidden'
	}

	public requestFullscreen(className: string): void {
		const elementByClassName: Element | undefined = document.getElementsByClassName(className)[0]
		if (!elementByClassName) return
		elementByClassName.requestFullscreen()
	}

	public exitFullscreen(): void {
		document.exitFullscreen()
	}

	public changeAFKState(value: boolean): void {
		this.isWasAFK$.next(value)
	}
}
